export function surveyReportBackTarget(visitId: string | undefined, viewerRole: string | null | undefined): string {
  if (viewerRole === 'FieldSurveyor') return '/today'
  return visitId ? `/visits/${visitId}/survey/complete` : '..'
}

export function surveyReportBackLabel(viewerRole: string | null | undefined): string {
  return viewerRole === 'FieldSurveyor' ? 'Back to Today' : 'Back to Complete Survey'
}
